import { useMutation, useQuery } from '@apollo/client/react';
import { Button, ButtonProps, chakra, Icon } from '@chakra-ui/react';
import { ScoComment } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { motion } from 'framer-motion';
import React, { useCallback } from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa6';
const ChakraMotionBox = chakra(motion.div);
type ToggleCommentFeaturedButtonProps = {
  comment?: ScoComment;
  commentId: string;
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
};
export const ToggleCommentFeaturedButton = (props: ToggleCommentFeaturedButtonProps) => {
  const query = useQuery(gql`
    query ($commentId: String!) {
      forum {
        id
        comment(commentId: $commentId) {
          id
          ${ToggleCommentFeaturedButton.fragments.ScoComment()}
        }
      }
    }
  `, {
    skip: !!props.comment,
    variables: {
      commentId: props.commentId
    }
  });
  const [toggleCommentFeatured, toggleCommentFeaturedMutation] = useMutation(gql`
    mutation ($input: ToggleCommentFeaturedInput!) {
      toggleCommentFeatured(input: $input) {
        comment {
          id
          ${ToggleCommentFeaturedButton.fragments.ScoComment()}
        }
      }
    }
  `);
  const comment = props.comment || query.data?.forum?.comment;
  const onClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    try {
      toggleCommentFeatured({
        variables: {
          input: {
            commentId: comment.commentId
          }
        }
      });
    } catch (err) {
      alert(`Error: ${err.toString()}`);
    }
  }, [comment?.commentId]);
  if (!comment) {
    return <></>;
  }
  return <ChakraMotionBox
  //@ts-ignore
  transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} whileHover={{
    scale: 1.2
  }} whileTap={{
    scale: 0.9
  }}>
      <Button color={comment.featuredAt ? 'actionActive' : props.color || 'actionPrimary'} cursor={'pointer'} minWidth={0} padding={0} size={(props.size || 'md') as any} variant={'ghost'} _hover={{
      color: `${comment.featuredAt ? 'actionActive' : 'white'}`,
      textDecoration: 'none'
    }} onClick={onClick}>
        <Icon as={comment.featuredAt ? FaStar : FaRegStar} />
      </Button>
    </ChakraMotionBox>;
};
ToggleCommentFeaturedButton.fragments = {
  ScoComment: () => gql`
    fragment _ on ScoComment {
      id
      commentId
      featuredAt
      featuredByUser {
        id
        fullName
      }
    }
  `
};